import { ArrowForward } from '@mui/icons-material'
import { useAssetsImpactOnRiskRatio } from 'hooks/perp/useAssetsImpactOnRiskRatio'
import { useRiskRatio } from 'hooks/perp/useRiskRatio'
import numbro from 'numbro'
import { memo } from 'react'
import { useAmount, useSelectedToken } from 'store/withdraw/hook'
import { AccountImpactItemWrap } from './style'

const Risk = memo(() => {
  const risk = useRiskRatio()
  const amount = useAmount()
  const selectedToken = useSelectedToken()
  const impactRisk = useAssetsImpactOnRiskRatio(amount, selectedToken?.name!)

  return (
    <AccountImpactItemWrap>
      <span>Risk:</span>
      <span className='right'>
        {numbro(risk).format({ output: 'percent', mantissa: 2 })}
        <ArrowForward
          sx={{
            width: 12,
            height: 12,
          }}
        />{' '}
        {numbro(impactRisk).format({ output: 'percent', mantissa: 2 })}
      </span>
    </AccountImpactItemWrap>
  )
})

export default Risk
